module.exports = __webpack_public_path__ + "img/appleton.93a4f50e.png";